import { render, staticRenderFns } from "./VideoManage.vue?vue&type=template&id=40ee5a3d&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports